import { IconType, Loader, QueryBoundary } from '@outdoria/ui';
import { SelectEntityButton } from '../../components';
import { useGetGatheringSpotTypesAll } from '@outdoria/api';

import s from './GatheringSpotsCreateSelectTypeView.module.scss';

export const GatheringSpotsCreateSelectTypeView = () => (
  <QueryBoundary fallback={<Loader />}>
    <Load />
  </QueryBoundary>
);

const Load = () => {
  const { data: gatheringSpotTypes } = useGetGatheringSpotTypesAll();

  return (
    <div className={s.view}>
      {gatheringSpotTypes.map(gatheringSpotType => (
        <SelectEntityButton
          key={gatheringSpotType.name}
          description={gatheringSpotType.description}
          icon={gatheringSpotType.icon as IconType}
          link={gatheringSpotType.gathering_spot_type_id}
          title={gatheringSpotType.name}
        />
      ))}
    </div>
  );
};
